import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Chip,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";
import Autocomplete from '@material-ui/lab/Autocomplete';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    }
});

const HeadphoneProductEditForm = props => {
    const { classes, formSettings, grades, editable, typicalProblems, initialValues, handleSubmit, translations, gradingCategories } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, setFieldValue, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                name="InventoryID"
                                value={values.InventoryID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.InventoryID && touched.InventoryID)}
                                placeholder={translations['article_id'] || 'Securaze ID'}
                                label={translations['article_id'] || 'Securaze ID'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="InventoryNumber"
                                value={values.InventoryNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.InventoryNumber && touched.InventoryNumber)}
                                placeholder={translations['inventory_number'] || 'Inventory number'}
                                label={translations['inventory_number'] || 'Inventory number'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SKU"
                                value={values.SKU}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SKU && touched.SKU)}
                                placeholder={translations['sku'] || 'SKU'}
                                label={translations['sku'] || 'SKU'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Order"
                                value={values.Order}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Order && touched.Order)}
                                placeholder={translations['order'] || 'Order'}
                                label={translations['order'] || 'Order'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="TransportColli"
                                value={values.TransportColli}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.TransportColli && touched.TransportColli)}
                                placeholder={translations['transport_colli'] || 'Transport colli'}
                                label={translations['transport_colli'] || 'Transport colli'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="Colli"
                                value={values.Colli}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Colli && touched.Colli)}
                                placeholder={translations['colli'] || 'Colli'}
                                label={translations['colli'] || 'Colli'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="SerialNumber"
                                value={values.SerialNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SerialNumber && touched.SerialNumber)}
                                placeholder={translations["serial_number"] || 'Serial number'}
                                label={translations["serial_number"] || 'Serial number'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SerialNumberLeft"
                                value={values.SerialNumberLeft}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SerialNumberLeft && touched.SerialNumberLeft)}
                                placeholder={translations["serial_number_left"] || 'Serial number left'}
                                label={translations["serial_number_left"] || 'Serial number left'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SerialNumberRight"
                                value={values.SerialNumberRight}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SerialNumberRight && touched.SerialNumberRight)}
                                placeholder={translations["serial_number_right"] || 'Serial number right'}
                                label={translations["serial_number_right"] || 'Serial number right'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="CaseModelNumber"
                                value={values.CaseModelNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.CaseModelNumber && touched.CaseModelNumber)}
                                placeholder={translations["case_model_number"] || 'Case model number'}
                                label={translations["case_model_number"] || 'Case model number'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Vendor"
                                value={values.Vendor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Vendor && touched.Vendor)}
                                placeholder={translations['vendor'] || 'Vendor'}
                                label={translations['vendor'] || 'Vendor'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ProductModel"
                                value={values.ProductModel}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ProductModel && touched.ProductModel)}
                                placeholder={translations['model'] || 'Model'}
                                label={translations['model'] || 'Model'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="InternalName"
                                value={values.InternalName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.InternalName && touched.InternalName)}
                                placeholder={translations["internal_name"] || 'Internal name'}
                                label={translations["internal_name"] || 'Internal name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["grading_category_text"] || "Please select grading category"}</InputLabel>
                                <Select
                                    name="GradingCategoryID"
                                    label={translations["grading_category"] || "Grading category"}
                                    margin={"dense"}
                                    value={values.GradingCategoryID.toString() || ''}
                                    onChange={handleChange}
                                >
                                    {(gradingCategories ? [...gradingCategories] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["select_grade"] || "Please select grade"}</InputLabel>
                                <Select
                                    name="GradeID"
                                    label={translations["grade"] || "Grade"}
                                    margin={"dense"}
                                    value={values.GradeID || ''}
                                    onChange={handleChange}
                                >
                                    {(grades ? [...grades] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                name="LabelComment1"
                                value={values.LabelComment1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LabelComment1 && touched.LabelComment1)}
                                placeholder={`${translations["label_comment"] || 'Label comment'} 1`}
                                label={`${translations["label_comment"] || 'Label comment'} 1`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LabelComment2"
                                value={values.LabelComment2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LabelComment2 && touched.LabelComment2)}
                                placeholder={`${translations["label_comment"] || 'Label comment'} 2`}
                                label={`${translations["label_comment"] || 'Label comment'} 2`}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="LabelComment3"
                                value={values.LabelComment3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LabelComment3 && touched.LabelComment3)}
                                placeholder={`${translations["label_comment"] || 'Label comment'} 3`}
                                label={`${translations["label_comment"] || 'Label comment'} 3`}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="LabelComment4"
                                value={values.LabelComment4}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LabelComment4 && touched.LabelComment4)}
                                placeholder={`${translations["label_comment"] || 'Label comment'} 4`}
                                label={`${translations["label_comment"] || 'Label comment'} 4`}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <Autocomplete
                                name={'TypicalProblemID'}
                                multiple
                                id="TypicalProblemIDMulti"
                                options={typicalProblems || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.TypicalProblemID}
                                onChange={(_, value) => setFieldValue('TypicalProblemID', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["choose_typical_problem"] || "Chose typical problem"}...`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <TextField
                                name="Notes"
                                value={values.Notes}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Notes && touched.Notes)}
                                placeholder={translations["notes"] || 'Notes'}
                                label={translations["notes"] || 'Notes'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Group"
                                value={values.Group || (translations["none"] || "None")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Group && touched.Group)}
                                placeholder={translations["group"] || "Group"}
                                label={translations["group"] || "Group"}
                                margin={"dense"}
                                fullWidth={true}
                                disabled
                            />

                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    style={{ width: '100%' }}
                                    type="submit"
                                    disabled={!(isValid && dirty) || isSubmitting || !editable}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(HeadphoneProductEditForm);
